// extracted by mini-css-extract-plugin
module.exports = {"timelineBlock":"TimelineBlock_timelineBlock__2Afg4"};